import React, { useEffect, useState } from 'react'
import BySearchField from './BySearchField'
import ByFilters from './ByFilters'

const SearchForm = (props) => {
  const getFilterlist = (data) => {
    props.filterlist(data)
  }
  return(
        <div className="formfields formfields-activityfinder">
          {/* Search Input form field */}
            <BySearchField {...props} />
            {/* Below is all filters dropdown */}
            <ByFilters filterlist={getFilterlist} {...props} />
        </div>
  )  
};

export default SearchForm;
